import { Box, Typography } from "@mui/material";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Col, InputNumber, Pagination, Row } from "rsuite";
import { numberFormatter } from "../../services/utils";
import "../../pages/CostToServe/costToServe.scss";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import MinusRoundIcon from "@rsuite/icons/MinusRound";
import { ClassNames } from "@emotion/react";

const Table = (props: any) => {
	const { TableSummaryData, totalPages } = props;

	let defaultPageSize: any, debounceTimeOutId: any;
	const [pageSize, setPageSize] = useState(10);
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [PageNumber, setPageNumber] = useState(1);
	const [pageSizeValue, setPageSizeValue] = useState(10);
	const [expandedRow, setExpandedRow] = useState<string | null>(null);

	const [isScenarioTableClick, setIsScenarioTableClick] = useState(false);
	const [SoldID, setSoldID] = useState(0);
	const [DropsPerWeek, setDropsPerWeek] = useState(0);
	const [TotalFreightCharge, setTotalFreightCharge] = useState(0);

	const headerStyle = {
		backgroundColor: "white",
		color: "black",
		border: "1px solid #bebebe",
		borderBottom: "3px solid rgba(134, 188, 37)",
	};
	const headersStyle = {
		backgroundColor: "white",
		color: "black",
		borderLeft: "1px solid #bebebe",
		borderRight: "1px solid #bebebe",
	};

	const HandleScenarioTable = (
		soldId: any,
		dropsPerWeek: any,
		TotalFreightCost: any
	) => {
		setSoldID(soldId);
		setDropsPerWeek(dropsPerWeek);
		setTotalFreightCharge(TotalFreightCost);

		setIsScenarioTableClick(true);
	};

	useEffect(() => {
		if (props.ClearScenarioTable) {
			setIsScenarioTableClick(false);
		}
	}, [props.ClearScenarioTable]);

	const nextChar = (c: string, index: number) => {
		return String.fromCharCode(c.charCodeAt(0) + index);
	};

	const handleExpansion = (itemId: any) => {
		const arr = props.expandedRows;
		let id = arr.includes(itemId?.name) ? null : itemId?.id;
		if (arr.includes(itemId?.name)) {
			arr.splice(arr.indexOf(itemId?.name), 1);
			setExpandedRow(null); // Reset expanded row
		} else {
			arr.push(itemId?.name);
			setExpandedRow(itemId?.name);
		}
		props.setExpendedRowArray(arr, id);
	};

	const handlePageChange = (newPage: React.SetStateAction<number>) => {
		setCurrentPage(newPage);
		props.handlePaginationAPI(pageSize, newPage);
	};

	const firstRowRef = useRef<HTMLTableRowElement>(null);
	const [firstRowHeight, setFirstRowHeight] = useState(0);
	useLayoutEffect(() => {
		if (firstRowRef.current)
			setFirstRowHeight(firstRowRef.current?.offsetHeight)
	}, [])
	return (
		<>
			<Box className="w-[100%] h-[63%] bg-white border-l border-r border-t border-[#bebebe] overflow-y-auto">
				<table className="fixed_header table-containers w-full">
					<tbody
						className="tbodyclass !h-[63%] tex-[0.75vw] border-separate"					>
						<tr className=" font-semibold sticky top-0 z-10 bg-white" ref={firstRowRef} >
							<th
								className="table-header-text alignCenter itemTableHeaders"
								style={headersStyle}
							>
								Customer
							</th>
							{expandedRow &&
								<th
									className="table-header-text alignCenter itemTableHeaders"
									style={headersStyle}
								>
									Ship Customer ID
								</th>}
							<th
								className="table-header-text alignCenter itemTableHeaders"
								style={headersStyle}
								colSpan={expandedRow ? 4 : 3}
							>
								Current Status
							</th>
							<th
								className="table-header-text alignCenter itemTableHeaders whitespace-nowrap"
								style={headersStyle}
							>
								Consolidation Opportunity ($) (Min-Max)
							</th>
						</tr>
						<tr className={` font-semibold sticky z-10 bg-white`} style={{ top: firstRowHeight }}>
							<th
								className="table-header-text alignCenter itemTableHeaders"
								style={headerStyle}
							>
								{/* Empty cell for alignment */}
							</th>
							{expandedRow &&
								<th
									className="table-header-text alignCenter itemTableHeaders"
									style={headerStyle}
								>
									{/* Empty cell for alignment */}
								</th>}
							{expandedRow &&
								<th
									className="table-header-text alignCenter itemTableHeaders"
									style={headerStyle}
								>
									Ship <br></br>to (City)
								</th>}
							<th
								className="table-header-text alignCenter itemTableHeaders"
								style={headerStyle}
							>
								Revenue<br></br>/Drop ($)
							</th>
							<th
								className="table-header-text alignCenter itemTableHeaders"
								style={headerStyle}
							>
								# of <br></br>Drops/wk.
							</th>
							<th
								className="table-header-text alignCenter itemTableHeaders"
								style={headerStyle}
							>
								Gross<br></br> Margin
							</th>
							<th
								className="table-header-text alignCenter itemTableHeaders"
								style={headerStyle}
							>
								{/* Empty cell for alignment */}
							</th>
						</tr>
						{TableSummaryData && TableSummaryData.length > 0 ? (
							TableSummaryData.map((d: any, index: any) => {
								const isExpanded =
									expandedRow === d.CUSTOMER_NAME;
								return (
									<React.Fragment key={index}>
										<tr
											className="table-cell-text font-normal"
											style={{
												opacity:
													expandedRow && !isExpanded
														? 0.5
														: 1,
											}}
										>
											<td className="table-cell-text alignCenter">
												<label
													className="rowClickIcon"
													onClick={() =>
														handleExpansion({
															name: d?.CUSTOMER_NAME,
															id: d?.CUSTOMER_ID,
														})
													}
												>
													{isExpanded ? (
														<MinusRoundIcon
															style={{
																marginRight:
																	"8px",
																cursor: "pointer",
															}}
														/>
													) : (
														<PlusRoundIcon
															style={{
																marginRight:
																	"8px",
																cursor: "pointer",
															}}
														/>
													)}
												</label>
												<label className="cursorPointer">
													{d?.CUSTOMER_NAME}
												</label>
											</td>
											{expandedRow &&
												<td className="table-cell-text alignCenter"></td>}
											{expandedRow &&
												<td className="table-cell-text alignCenter"></td>}
											<td className="table-cell-text alignCenter">
												${numberFormatter(
													d?.revenuePerDrop
												)}$
											</td>
											<td className="table-cell-text alignCenter">{d?.dropsPerWeek}</td>
											<td className="table-cell-text alignCenter">
												{numberFormatter(d?.GMprcnt)}%
											</td>
											<td className="table-cell-text alignCenter">
												$
												{numberFormatter(
													d?.consolidatedOpportunityLowerLimit
												)}{" "}
												- $
												{numberFormatter(
													d?.consolidatedOpportunityUpperLimit
												)}
											</td>
										</tr>
										{isExpanded &&
											d.list.map((d1: any) => {
												return (
													<tr
														className=" font-normal cursor-pointer"
														key={d1?.shipToID}
														onClick={() =>
															HandleScenarioTable(
																d1?.shipToID,
																d1?.dropsPerWeek,
																d1?.totalFreightCostPerDrop
															)
														}
													>
														<td className="table-cell-text alignCenter"></td>
														{expandedRow &&
															<td className="table-cell-text alignCenter">{d1?.shipToID}</td>}
														{expandedRow &&
															<td className="table-cell-text alignCenter">
																{d1?.shipToCity}
															</td>}
														<td className="table-cell-text alignCenter">
															${numberFormatter(
																d1?.revenuePerDrop
															)}
														</td>
														<td className="table-cell-text alignCenter">
															{d1?.dropsPerWeek}
														</td>
														<td className="table-cell-text alignCenter">
															{numberFormatter(
																d1?.GMprcnt
															)}
															%
														</td>
														<td className="table-cell-text alignCenter">
															$
															{numberFormatter(
																d1?.consolidatedOpportunityLowerLimit
															)}{" "}
															- $
															{numberFormatter(
																d1?.consolidatedOpportunityUpperLimit
															)}
														</td>
													</tr>
												);
											})}
									</React.Fragment>
								);
							})
						) : (
							<></>
						)}
					</tbody>
				</table>
			</Box>
			<Box className="w-full h-[8%]  bg-white border-l border-r border-b border-[#bebebe] flex  justify-center items-center">
				<Pagination
					prev
					next
					first
					last
					ellipsis
					boundaryLinks
					maxButtons={2}
					size="xs"
					layout={["pager", "skip"]}
					total={50}
					limit={4}
					activePage={currentPage}
					onChangePage={handlePageChange}
				/>
			</Box>
			<Box className="w-full h-[5%] ">
				{isScenarioTableClick ? (
					<div className="subHeadright">
						Scenario Analysis for Customer : {SoldID}
					</div>
				) : (
					<div className="subHeadright">
						Scenario Analysis for Customers
					</div>
				)}
			</Box>
			<Box className="w-full h-[24%] bg-white border border-[#bebebe]  overflow-y-auto relative">
				{isScenarioTableClick ? (
					<>
						<table className="fixed_header crossSell ">
							<tbody className="w-[99.8%] p-0"
							>
								<tr
									className="border border-[#bebebe]  font-bold cursor-pointer sticky"
								>
									<th
										className="stickyHeader alignCenter border border-[#bebebe] "
										rowSpan={1}
										style={headerStyle}
									>
										<Box
											display="flex "
											style={{
												justifyContent: "center",
												alignItems: "center",
												height: "100%",
											}}
										>
											<Typography className="table-header-text">
												Attributes{" "}
											</Typography>
										</Box>
									</th>
									<th
										className="table-header-text stickyHeader alignCenter border border-[#bebebe]"
										rowSpan={1}
										style={headerStyle}
									>
										<Box
											display="flex"
											style={{
												justifyContent: "center",
												alignItems: "center",
												height: "100%",
											}}
										>
											<Typography className="table-header-text">
												{" "}
												Current Scenario{" "}
											</Typography>
										</Box>
									</th>

									{Array.from(
										{ length: DropsPerWeek - 1 },
										(_, index) => (
											<th
												key={index}
												className="stickyHeader alignCenter border border-[#bebebe]"
												rowSpan={1}
												style={headerStyle}
											>
												<Box
													display="flex"
													style={{
														justifyContent:
															"center",
														alignItems: "center",
														height: "100%",
													}}
												>
													<Typography
														className="table-header-text"
													>
														{" "}
														Scenario{" "}
														{nextChar(
															"A",
															index
														)}{" "}
													</Typography>
												</Box>
											</th>
										)
									)}
									<th
										className="stickyHeader alignCenter border border-[#bebebe]"
										rowSpan={1}
										style={headerStyle}
									>
										<Box
											display="flex"
											style={{
												justifyContent: "center",
												alignItems: "center",
												height: "100%",
											}}
										>
											<Typography className="table-header-text">
												{" "}
												Scenario Will Call{" "}
											</Typography>
										</Box>
									</th>
								</tr>
								<tr className="">
									<td className="table-cell-text alignCenter">Drops / Week</td>
									<td className="table-cell-text alignCenter">
										{numberFormatter(DropsPerWeek)}
									</td>
									{Array.from(
										{ length: DropsPerWeek },
										(_, index) =>
											index > 0 &&
											index !== DropsPerWeek && (
												<td
													key={DropsPerWeek - index}
													className="table-cell-text alignCenter"
												>
													{numberFormatter(
														DropsPerWeek - index
													)}
												</td>
											)
									)}
									<td className="table-cell-text alignCenter">
										{numberFormatter(0)}
									</td>
								</tr>
								<tr className="">
									<td className="table-cell-text alignCenter">
										Freight Cost / Drop ($)
									</td>
									<td className="table-cell-text alignCenter">
										$
										{numberFormatter(
											DropsPerWeek * TotalFreightCharge
										)}
									</td>
									{Array.from(
										{ length: DropsPerWeek },
										(_, index) =>
											index > 0 &&
											index !== DropsPerWeek && (
												<td
													key={DropsPerWeek - index}
													className="table-cell-text alignCenter"
												>
													{numberFormatter(
														(DropsPerWeek - index) *
														TotalFreightCharge
													)}
												</td>
											)
									)}
									<td className="table-cell-text alignCenter">-</td>
								</tr>
								<tr className="">
									<td className="table-cell-text alignCenter">
										Consolidation Opportunity ($)
									</td>
									<td className="table-cell-text alignCenter">
										$
										{numberFormatter(
											DropsPerWeek * TotalFreightCharge -
											DropsPerWeek *
											TotalFreightCharge
										)}
									</td>
									{Array.from(
										{ length: DropsPerWeek },
										(_, index) =>
											index > 0 &&
											index !== DropsPerWeek && (
												<td
													key={DropsPerWeek - index}
													className="table-cell-text alignCenter"
												>
													{numberFormatter(
														DropsPerWeek *
														TotalFreightCharge -
														(DropsPerWeek -
															index *
															TotalFreightCharge)
													)}
												</td>
											)
									)}
									<td className="table-cell-text alignCenter">
										$
										{numberFormatter(
											DropsPerWeek * TotalFreightCharge
										)}
									</td>
								</tr>
							</tbody>
						</table>
					</>
				) : (
					<span className="h-full flex justify-center items-center italic font-normal text-[2.5vh] text-center text-black">
						Click on the Sold ID to get the Scenario table
					</span>
				)}
			</Box>
		</>
	);
};

export default Table;
